<template>
    <div class="content">
        <div class="content-head">
            <el-form :inline="true" class="demo-form-inline search-form-row">
                <el-form-item label="付款时间">
                    <el-date-picker v-model="params.paydate_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.paydate_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="录入时间">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="凭证状态">
                    <el-select v-model="params.status" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in Statusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" 汇款单位">
                    <el-input autocomplete="on" name="keyword" v-model="params.keyword" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="汇款金额">
                    <el-input autocomplete="on" name="Receipt_Amount" v-model="params.Receipt_Amount" placeholder="" @input="handleInput($event, 'params', 'Receipt_Amount')" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOrdersPaymentReceipts(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                收据管理列表
                <span>
                    <el-button type="primary" icon="el-icon-plus" @click="openReceipt(1)">新增</el-button>

                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button>
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="handleExportPaymentReceipts">导出结果分配明细</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table   :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="tableData" border :height="maxheight" style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                <!-- <el-table-column prop="Receipt_ID" label="ID" width="80" align="center" fixed="left" /> -->
                <el-table-column prop="Receipt_BankName" label="汇入银行" align="center" show-overflow-tooltip width="80"></el-table-column>
                <el-table-column prop="Receipt_Type" label="凭证类型" width="80" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="Receipt_Code" label="汇款单位" show-overflow-tooltip align="center" min-width="200"></el-table-column>
                <el-table-column prop="Receipt_PayDate" label="付款日期" show-overflow-tooltip width="100" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.Receipt_PayDate | formatDate }}
                    </template>
                </el-table-column>
                <el-table-column prop="Receipt_Amount" width="100" label="汇款金额" show-overflow-tooltip align="center">
                    <template slot-scope="scope">￥ {{ scope.row.Receipt_Amount }}</template>
                </el-table-column>
                <el-table-column prop="Receipt_Addtime" width="150" label="录入时间" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        {{ scope.row.Receipt_Addtime | formatDates }}
                    </template>
                </el-table-column>
                <el-table-column prop="Receipt_SourceBank" label="汇出银行" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="Last_Amount" width="100" label="剩余金额" show-overflow-tooltip align="center">
                    <template slot-scope="scope">￥ {{ scope.row.Last_Amount }}</template>
                </el-table-column>
                <el-table-column prop="Payment_Receipt_Status" width="60" label="状态" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.Payment_Receipt_Status == 0">作废</span>
                        <span v-else-if="scope.row.Payment_Receipt_Status == 1">正常</span>
                        <span v-else>禁用</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="openReceipt(2, scope.row)" v-if="scope.row.Payment_Receipt_Status > 0">修改</span>
                            <span class="operation-bar-block" @click="openReceipt(3, scope.row)" v-if="scope.row.Payment_Receipt_Status <= 0">查看</span>
                            <span class="operation-bar-block" v-if="scope.row.Payment_Receipt_Status > 0" @click="getCancelOrdersPaymentReceipt(scope.row,scope.row.Payment_Receipt_Status > 1?1:2)">{{scope.row.Payment_Receipt_Status != 2 ? '禁用' : '启用'}}</span>
                            <span class="operation-bar-block operation-bar-block-del" v-if="scope.row.Receipt_Amount == scope.row.Last_Amount" @click="getCancelOrdersPaymentReceipt(scope.row,0)">作废</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>   
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <!-- 付款凭证弹层组件移植为复用组件，见文件底部引用 -->
        <!-- 付款凭证弹层组件复用 -->
        <PaymentVoucher ref="PaymentVoucherDialog" @success="onRefresh" />
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import PaymentVoucher from '@/components/PaymentVoucher/index.vue';
import { myMixin } from '@/utils/mixin.js';
import { cloneDeep } from 'lodash';
import { downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
export default {
    name: 'paymentVoucher',
    mixins: [myMixin],
    components: {
        Pagination,
        PaymentVoucher
    },
    data() {
        return {
            loadingBtn: false,
            params: {},
            tableData: [],
            Statusopt: [
                { value: 0, label: '正常' },
                { value: 1, label: '作废' },
                { value: 3, label: '禁用' },
                { value: 2, label: '全部' }
            ],
            
        };
    },
    mounted() {
        this.onRefresh();
    },
    methods: {
        /*
    重置查询
    */
        onRefresh() {
            this.params = {
                paydate_start: '',
                paydate_end: '',
                date_start: '',
                date_end: '',
                keyword: '',
                Receipt_Amount: '',
                status: 0
            };
            this.getOrdersPaymentReceipts(true);
        },
        /*
    列表查询
    */
        getOrdersPaymentReceipts(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }

            this.$newsApi
                .getOrdersPaymentReceipts(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        /*
      列表导出
    */
        getOrdersDistributetTransferExport() {
            this.$newsApi.getOrdersDistributetTransferExport(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },
        filteropt() {
            let params = cloneDeep(this.params);
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getOrdersPaymentReceipts();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getOrdersPaymentReceipts();
        },
        handleExportPaymentReceipts() {
            this.$newsApi.ordersPaymentReceiptsExport(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },
        openReceipt(type, row) {
            this.$refs.PaymentVoucherDialog.open(type, row || {});
        },
        async handleOpen(type, el) {
            this.isControls = type;
            this.result = {
                Last_Amount: '',
                Payment_Receipt_File: '',
                Payment_Receipt_Source: '',
                Payment_Receipt_Status: '',
                Payment_Receipt_User: '',
                Receipt_Addtime: '',
                Receipt_Amount: '',
                Receipt_BankName: '',
                Receipt_Code: '',
                Receipt_ID: '',
                Receipt_PayDate: '',
                Receipt_SourceBank: '',
                Receipt_Type: '',
                Receipt_Bankstatus: '',
                Receipt_Types: 0
            };

            this.loadingText = '针对转账、银行承兑汇票类型支持AI智能识别,文件支持bmp,jpg,gif,png,pdf格式';
            this.isDialog = true;
            if (this.isControls == 1) {
                try {
                    // 并行请求，减少等待时间
                    const [res1, res2] = await Promise.all([this.$newsApi.common.getBankname(), this.$newsApi.common.getReceiptType()]);

                    // 处理银行名称下拉框
                    if (res1.data.Resultcode === 0) {
                        this.Banknameopt = Object.entries(res1.data.data).map(([key, value]) => {
                            return { value: Number(key), label: value };
                        });
                    }
                    // 处理收据类型下拉框
                    if (res2.data.Resultcode === 0) {
                        this.ReceiptTypeopt = Object.entries(res2.data.data).map(([key, value]) => {
                            return { value: Number(key), label: value };
                        });
                    }
                } catch (error) {
                    console.error('获取订单收据信息时出错:', error);
                }
            } else {
                this.getOrdersPaymentReceiptByID(el.Receipt_ID);
            }
            console.log(this.isControls);
        },
        /*
    查询详情数据
    */
        async getOrdersPaymentReceiptByID(id) {
            try {
                // 并行请求，减少等待时间
                const [res1, res2, res, res3, res4] = await Promise.all([this.$newsApi.common.getBankname(), this.$newsApi.common.getReceiptType(), this.$newsApi.getOrdersPaymentReceiptByID({ Receipt_ID: id, action: 'edit' }), this.$newsApi.getOrdersPaymentReceiptsDistributeList({ Receipt_ID: id }), this.$newsApi.getMKLogsByTargetID({ Target_ID: id, Target_Type: 1 })]);
                // 检查收据详情结果
                if (res.data.Resultcode === 0) {
                    this.result = {
                        ...res.data.data,
                        Receipt_Bankstatus: 0,
                        Receipt_Types: 0
                    };
                }
                // 处理银行名称下拉框
                if (res1.data.Resultcode === 0) {
                    this.Banknameopt = Object.entries(res1.data.data).map(([key, value]) => {
                        if (value === this.result.Receipt_BankName) {
                            this.result.Receipt_Bankstatus = Number(key);
                        }
                        return { value: Number(key), label: value };
                    });
                }
                // 处理收据类型下拉框
                if (res2.data.Resultcode === 0) {
                    this.ReceiptTypeopt = Object.entries(res2.data.data).map(([key, value]) => {
                        if (value === this.result.Receipt_Type) {
                            this.result.Receipt_Types = Number(key);
                        }
                        return { value: Number(key), label: value };
                    });
                }
                if (res3.data.Resultcode === 0) {
                    this.ReceiptLogs = res3.data.data;
                }
                if (res4.data.Resultcode === 0) {
                    this.Processinglog = res4.data.data;
                }
                console.log(this.result.Receipt_Types, this.Banknameopt, this.ReceiptTypeopt, 'this.result.Receipt_Types');
                console.log(this.result, 'result');
            } catch (error) {
                console.error('获取订单收据信息时出错:', error);
            }
        },
        getAddOrdersPaymentReceipt(json) {
            this.$newsApi.getAddOrdersPaymentReceipt(json).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        message: '添加成功',
                        type: 'success',
                        duration: 2000,
                        onClose: () => {
                            this.handleClose();
                            this.onRefresh();
                        }
                    });
                }
            });
        },

        getCancelOrdersPaymentReceipt(el,status) {
            this.$confirm(status == 0 ?'作废后该凭证将无法使用，确定要作废凭证吗?':'确定要修改凭证状态吗?', '注意', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$newsApi.getCancelOrdersPaymentReceipt({ Receipt_ID: el.Receipt_ID, PaymentStatus: status }).then((res) => {
                        if (res.data.Resultcode == 0) {
                            this.$message({
                                type: 'success',
                                message: '操作成功!',
                                duration: 2000,
                                onClose: () => {
                                    this.onRefresh();
                                }
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        handleConfirmAddReceipt() {
            this.historyAttachmentShow = false;
            if (this.pendingReceiptData) {
                this.getAddOrdersPaymentReceipt({ json: JSON.stringify(this.pendingReceiptData) });
                this.pendingReceiptData = null;
            }
        },
    }
};
</script>
<style scoped lang="scss">
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}

.search-form-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .el-form-item {
        margin-right: 12px;
        margin-bottom: 8px;
        min-width: 0;
        flex-shrink: 0;
    }

    .el-form-item:last-child {
        margin-right: 0;
    }

    .el-input,
    .el-select,
    .el-date-picker {
        width: 130px !important;
        min-width: 0 !important;
    }

    .el-form-item label {
        white-space: nowrap;
    }
}
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>
